import {makeStyles} from "tss-react/mui";
import logoLight from '~/src/assets/logo-light.png';

export const useLayoutStyles = makeStyles()((theme) => ({
  layout: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh",
    width: "100%",
    background: theme.palette.background.default,
  },
  logo: {
    height: 43,
    width: 192,
    margin: "auto 0",
    backgroundImage: `url(${logoLight})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
  },
}));
